const hostnames = {
    DEV: 'dev-hokkaido.zeiss.com',
    DEV2: 'dev2-hokkaido.zeiss.com',
    STAGE: 'stage-hokkaido.zeiss.com',
    UAT: 'uat-hokkaido.zeiss.com',
    PTEST: 'ptest-hokkaido.zeiss.com',
    PRODEU: 'surgicalcloud.eu.zeiss.com',
    PRODUS: 'surgicalcloud.us.zeiss.com',
    PRODIND: 'surgicalcloud.ind.zeiss.com',
}

export const getEnv = () => {
    const hostname = window.location.hostname
    const env = Object.keys(hostnames).find(key => hostnames[key] === hostname)
    return env || 'PRODEU'
}
